import { Heading, Page } from '@oliasoft-open-source/react-ui-library';

type MaintenancePageProps = {
  message?: string;
};
const MaintenancePage = ({ message }: MaintenancePageProps) => {
  return (
    <Page left={0}>
      <Heading top>{message || 'This page is currently under maintenance'}</Heading>
    </Page>
  );
};

export { MaintenancePage };
